// extracted by mini-css-extract-plugin
export var btn = "news_email-module--btn--d2925";
export var form = "news_email-module--form--51b1e";
export var inpt = "news_email-module--inpt--73392";
export var msg = "news_email-module--msg--5a5bc";
export var wrap = "news_email-module--wrap--edcb8";